import { convertToPDPDeepLink } from '@common/pdp';
import { ColorSwatchItemList, PdpBrowsingType } from '@domains/pdp-common';

import { ProductSwatchItem } from '../components/ProductSwatchCard';

export const convertToComponentProps = (items: ColorSwatchItemList[]): ProductSwatchItem[] => {
  return items.map((item): ProductSwatchItem => {
    const imgUrl = new URL(item.image_url);
    const { searchParams } = imgUrl;

    searchParams.set('width', '144');
    searchParams.set('height', '174');
    searchParams.set('quality', '80');
    searchParams.set('transparent', 'true');
    searchParams.set('format', 'png');

    return {
      id: item.catalog_product_id ?? '',
      imageUrl: imgUrl.toString(),
      productUrl: `/catalog/products/${item.catalog_product_id}`,
      deeplinkUrl: convertToPDPDeepLink({
        browsing_type: item.type ?? PdpBrowsingType.NATIVE_BROWSER,
        product_url: item.url,
        shop_id: item.shop_id ?? '',
        shop_product_no: null,
        catalog_product_id: item.catalog_product_id ?? '',
      }),
      isSelected: item.is_selected ?? false,
      isDimmed: item.is_dimmed ?? false,
      statusText: item.status_text
        ? {
            text: item.status_text.text,
            color: {
              normal: item.status_text.color?.normal ?? '',
            },
          }
        : undefined,
      ubl: item.ubl
        ? {
            object: {
              section: item.ubl.object?.section ?? '',
              type: item.ubl.object?.type ?? '',
              id: item.ubl.object?.id ?? '',
              idx: item.ubl.object?.idx ?? 0,
              url: item.ubl.object?.url ?? null,
            },
            server_log: item.ubl.server_log ?? '',
          }
        : undefined,
    };
  });
};
